'use client';
import { useState, useEffect } from 'react'
import dynamic from 'next/dynamic'
import Link from 'next/link'
import LoadingSpinner from '@/components/loadingSpinner';
import { ChevronLeftIcon } from '@heroicons/react/20/solid'
import Footer from '../../components/home/footer'
import { ResourcesList } from '@utils/resourcesList';
import { sendToSlack } from '@utils/api'
import Image from 'next/image';
import Seo from '@/components/seo';

const Header = dynamic(
  () => import('../../components/header'),
  { ssr: false }
)
const SingleResource = ({resource}) => {
  const [ email, setEmail ] = useState('')
  const [ error, setError ] = useState('')
  const [ unlocked, setUnlocked ] = useState(false)
  const [ loading, setLoading ] = useState(false)

  const unlockResource = async (email) => {
    setLoading(true)
    // await sent to slack
    await sendToSlack({
      type: 'free-resource',
      email: email,
      name: resource.title, 
    }) 
    //console.log(email)
    if(email) {
      setUnlocked(true)
    } else {
      setUnlocked(false)
    }
  };

  return (
    <>
      <Seo title={`${resource.title} | Pinto Financial`} description={resource.description} />

      <Header />
      <div className="relative bg-white max-w-7xl mx-auto px-4 sm:px-6">

        <div className="pb-24 sm:pb-32 lg:grid lg:grid-cols-2 lg:gap-x-8 lg:py-20">
          <div className="px-6 lg:px-0 lg:pt-4">
            <div className="mx-auto max-w-2xl">
              <div className="max-w-lg">
                <div className="">
                  <Link href="/free-resources" className="inline-flex space-x-6 hover:text-pinto">
                    <span className="hover:text-pinto inline-flex items-center space-x-2 text-sm font-medium leading-6 text-gray-600">
                      <ChevronLeftIcon className="h-5 w-5 text-gray-400 hover:text-pinto" aria-hidden="true" />
                      <span>Back to free resources</span>
                    </span>
                  </Link>
                </div>
                <h1 className="mt-10 text-4xl tracking-tight text-gray-900 sm:text-6xl">
                  {resource.title}
                </h1>
                <p className="mt-6 text-lg leading-8 text-gray-600">
                  {resource.description}
                </p>
                
                {unlocked && (
                <div className="mt-10 flex items-center gap-x-6">  
                  <Link
                    target={'_blank'} 
                    href={resource.sheetCopyUrl}
                    className="flex items-center gap-x-2 w-1/2 rounded-md bg-white py-3 px-5 sm:px-10 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                  >
                    Copy To Your Drive
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 01-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 011.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 00-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 01-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 00-3.375-3.375h-1.5a1.125 1.125 0 01-1.125-1.125v-1.5a3.375 3.375 0 00-3.375-3.375H9.75" />
                    </svg>

                  </Link>
                  <Link
                    target={'_blank'} 
                    href={resource.sheetViewUrl}
                    className="flex items-center gap-x-2 w-1/2 sm:px-10 rounded-md bg-pinto py-3 px-5 text-base font-semibold text-white shadow-sm hover:bg-pinto-dark focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-pinto"
                  >
                    View resource
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 19.5l15-15m0 0H8.25m11.25 0v11.25" />
                    </svg>
 
                  </Link>
                </div>  
                )} 
                
                {!unlocked && 
                <>
                  <div className="mt-10 flex items-center gap-x-6">
                    <form onSubmit={(e) => { unlockResource(email); e.preventDefault(); }} className="sm:flex sm:w-full sm:max-w-lg">
                      <div className="min-w-0 flex-1">
                        <label htmlFor="hero-email" className="sr-only">
                          Email address
                        </label>
                        <input
                          id="hero-email"
                          type="email"
                          className="block w-full rounded-md border border-gray-300 px-5 py-3 text-base text-gray-900 placeholder-gray-500 shadow-sm focus:border-pinto focus:ring-pinto"
                          placeholder="Enter your email"
                          value={email}
                          required
                          onChange={(e) => setEmail(e.target.value)}
                        />
                      </div>
                      <div className="mt-4 sm:mt-0 sm:ml-3">
                        <button
                          type="submit"
                          className="sm:px-10 inline-flex items-center gap-x-2 rounded-md bg-pinto py-3 px-5 text-base font-semibold text-white shadow-sm hover:bg-pinto-dark focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-pinto"
                        >
                          {loading ?  
                          <LoadingSpinner size={6}/> :
                          <>
                            Unlock Download
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="-mr-0.5 w-6 h-6">
                              <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 10.5V6.75a4.5 4.5 0 119 0v3.75M3.75 21.75h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H3.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z" />
                            </svg>
                          </>
                          } 
                        </button>
                      </div>
                    </form>
                  </div>
                  <p className="text-sm text-gray-400">*Email is required for download</p>
                </> 
                }
              </div>
            </div>
          </div>
          <div className="mt-20 sm:mt-24 md:mx-auto md:max-w-2xl lg:mx-0 lg:mt-0 lg:w-screen">
            <div className="shadow-lg md:rounded-3xl">
              <div className="bg-pinto [clip-path:inset(0)] md:[clip-path:inset(0_round_theme(borderRadius.3xl))]">
                <div className="w-full h-auto lg:w-[672px] lg:h-[448px] relative pl-6 pt-8 sm:pt-16 md:pl-16 md:pr-0">
                  <div className="w-full h-full mx-auto max-w-2xl md:mx-0 md:max-w-none" >
                    <div className="w-full h-full overflow-hidden rounded-tl-xl" >
                      <Image
                        width={800}
                        height={500}
                        src={resource.imageUrl}
                        alt="Download"
                        className="w-full h-full max-h-96 object-cover object-left"
                        unoptimized
                      />
                    </div>
                  </div>
                  <div
                    className="pointer-events-none absolute inset-0 ring-1 ring-inset ring-black/10 md:rounded-3xl"
                    aria-hidden="true"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <Footer />
    </>
  )
}

export default SingleResource


export async function getStaticPaths() {
  return {
    paths: ResourcesList.map((resource) => ({
      params: {
        resourceId: resource.slug,
      },
    })),
    fallback: false,
  };
}

export async function getStaticProps({ params }) {
  const resource = ResourcesList.filter((e) => e.slug == params.resourceId)[0];

  return {
    props: {
      resource,
    },
    revalidate: 1,
  };
}
